import { css } from 'linaria';
import { mobile } from 'style/mixins';
import { between } from 'polished';
import fonts from 'style/fonts';
export const about = "a16tcdio";
export const center = "ckic7ws";
export const centerText = "c1pha5up";
export const title = "t14d12p1";
export const image = "i2hec1a";
export const text = "t1rp125z";
export const email = "e334vcb";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/about/styles.linaria.css");